import { formatWeekDate, MONTHS_RU } from "./formatWeek";

export const HEATMAP_GRAINS = [
  { value: "week", label: "Неделя", prepositional: "неделю" },
  { value: "month", label: "Месяц", prepositional: "месяц" },
  { value: "quarter", label: "Квартал", prepositional: "квартал" },
  { value: "half", label: "Полгода", prepositional: "полгода" },
];

function yearMonthFromWeek(weekIso) {
  const [year, month] = weekIso.split("-");
  return { year, month: Number(month) };
}

export function periodKeyFromWeek(grain, weekIso) {
  if (grain === "week") return weekIso;
  const { year, month } = yearMonthFromWeek(weekIso);
  if (grain === "month") {
    return `${year}-${String(month).padStart(2, "0")}`;
  }
  if (grain === "quarter") {
    return `${year}-Q${Math.floor((month - 1) / 3) + 1}`;
  }
  if (grain === "half") {
    return `${year}-H${month <= 6 ? 1 : 2}`;
  }
  return weekIso;
}

export function periodStartIso(grain, period) {
  if (grain === "week") return period;
  if (grain === "month") return `${period}-01`;
  const [year, rest] = period.split("-");
  if (grain === "quarter") {
    const n = Number(rest.slice(1));
    const month = String((n - 1) * 3 + 1).padStart(2, "0");
    return `${year}-${month}-01`;
  }
  if (grain === "half") {
    const n = Number(rest.slice(1));
    return n === 1 ? `${year}-01-01` : `${year}-07-01`;
  }
  return period;
}

export function periodsFromWeeks(grain, weeks) {
  const keys = [];
  const seen = new Set();
  for (const weekIso of weeks) {
    const key = periodKeyFromWeek(grain, weekIso);
    if (!seen.has(key)) {
      seen.add(key);
      keys.push(key);
    }
  }
  return keys;
}

export function snapPeriod(nextGrain, currentGrain, currentPeriod, weeks) {
  const list = periodsFromWeeks(nextGrain, weeks);
  if (list.length === 0) return "";
  const anchor =
    currentGrain === "week" ? currentPeriod : periodStartIso(currentGrain, currentPeriod);
  const candidate = periodKeyFromWeek(nextGrain, anchor);
  if (list.includes(candidate)) return candidate;
  const weeksInCurrent = weeks.filter(
    (weekIso) => periodKeyFromWeek(currentGrain, weekIso) === currentPeriod,
  );
  if (weeksInCurrent.length > 0) {
    return periodKeyFromWeek(nextGrain, weeksInCurrent[0]);
  }
  return list[0];
}

export function formatPeriodLabel(grain, period) {
  if (grain === "week") return formatWeekDate(period);
  if (grain === "month") {
    const [year, month] = period.split("-");
    return `${MONTHS_RU[Number(month) - 1]} ${year}`;
  }
  const [year, rest] = period.split("-");
  const n = rest.slice(1);
  if (grain === "quarter") return `${n} кв. ${year}`;
  if (grain === "half") return `${n} пол. ${year}`;
  return period;
}
